<template>
    <div class="main_apply main_container">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="联合比对库资源" name="second">
            <el-form :model="formData2"  ref="formData2" :rules="rulesData2" label-width="150px" class="demo-ruleForm myForm" style="width: 70%; margin: auto;">
                <div class="item_box">
                   <div class="title_sty">申请人基本信息</div>
                    <el-form-item label="申请人姓名:" prop="RequesterName" >
                        <el-input v-model="formData2 && formData2.RequesterName" class="inpItem"></el-input>
                    </el-form-item>
                    <el-form-item label="申请人电话:" prop="RequesterPhoneNum" >
                        <el-input v-model="formData2 && formData2.RequesterPhoneNum" disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="所在单位:" prop="RequesterOrganisation" >
                        <el-input v-model="formData2 && formData2.RequesterOrganisation"></el-input>
                    </el-form-item>
                    <el-form-item label="个人身份证明:"  required prop="PersonIdentification">
                        <div v-for="(item, i) in (formData2 && formData2.PersonIdentification)" :key="item.FileGuid" class="input_box" >
                            <div :id="'indexImg_'+item.FileGuid" :ref="'indexImg_'+item.FileGuid" v-if="ifFileNmae4">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" >
                                        <span  class="input_fileName" v-if="ifFileNmae4" style="display:inline-block;color:#606266;">
                                            {{ item.FileName }}
                                        </span>
                                        <a class="view_a" target="_blank" id="test" @click="showImgFn(item.FileGuid)">
                                            查看
                                            <img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid">
                                        </a>
                                    </li>
                                </ul>
                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid" download="个人身份证明" title="下载"  target="_blank" class="download_a">
                                    下载
                                </a>
                            </div>
                        </div>
                        <el-button size="small" type="primary" @click="uploadAuth2(0)">点击上传</el-button>
                        <el-button  :data-img="url" type="text" size="small" @click="$imgPreview">模板</el-button>
                        <p class="tipText">个人身份证明为作者本人身份证、学生证、教师证、护照等可证明本人身份的其中一项证件扫描件，支持gif、png、jpg格式
                            <!-- <br>请一次性上传所有文件 -->
                        </p>
                    </el-form-item>
                </div>
                <div class="item_box">
                    <div class="title_sty">待撤文章信息</div>
                    <el-form-item label="题目名称:" prop="ArticleName"  >
                        <el-input v-model="formData2 && formData2.ArticleName"></el-input>
                        <!-- <div class="el-upload__tip">请输入待撤文章的题目名称</div> -->
                    </el-form-item>
                    <el-form-item label="作者:" prop="Author">
                        <el-input v-model="formData2 && formData2.Author"></el-input>
                        <!-- <div  class="el-upload__tip">请输入待撤文章的作者</div> -->
                    </el-form-item>
                    <el-form-item label="单位允许撤除证明:" prop="UnitIdentification"  >
                        <!-- <el-input v-model="formData2.UnitIdentification[0].FileName" class="input_fileName" v-if="ifFileNmae1"></el-input> -->
                        <div :id="'indexImg_'+(formData2.UnitIdentification && formData2.UnitIdentification[0].FileGuid)" :ref="'indexImg_'+(formData2.UnitIdentification && formData2.UnitIdentification[0].FileGuid)" v-if="ifFileNmae5">
                            <ul style="display:inline-block;">
                                <li style="display:inline-block;" ><span  class="input_fileName" v-if="ifFileNmae5" style="display:inline-block;color:#606266;">{{formData2.UnitIdentification && formData2.UnitIdentification[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(formData2.UnitIdentification && formData2.UnitIdentification[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData2.UnitIdentification && formData2.UnitIdentification[0].FileGuid)"></a></li>
                            </ul>
                            <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData2.UnitIdentification && formData2.UnitIdentification[0].FileGuid)" download="单位允许撤除证明模板" title="下载"  target="_blank" class="download_a">
                                下载
                            </a>
                        </div>


                        <el-button size="small" type="primary" @click="uploadAuth2(1)">点击上传</el-button>
                        <span class="model_span" style="margin-left:10px;">
                             <a :href="authImgUrl+'/api/Common/GetTemplateFile'" download="知网撤除比对申请表" title="知网撤除比对申请表"  target="_blank" class="download_a">
                                模板
                            </a>
                        </span>
                        <p class="tipText">证明必须加盖检测单位管理部门公章，支持gif、png、jpg格式</p>
                    </el-form-item>
                    <el-form-item label="检测报告单:" prop="CheckReport" >
                        <div :id="'indexImg_'+(formData2.CheckReport && formData2.CheckReport[0].FileGuid)" :ref="'indexImg_'+(formData2.CheckReport && formData2.CheckReport[0].FileGuid)" v-if="ifFileNmae6">
                            <ul style="display:inline-block;">
                                <li style="display:inline-block;" >
                                    <span  class="input_fileName" v-if="ifFileNmae6" style="display:inline-block;color:#606266;">
                                        {{ formData2.CheckReport && formData2.CheckReport[0].FileName }}
                                    </span>
                                    <a class="view_a" target="_blank" id="test" @click="showImgFn((formData2.CheckReport && formData2.CheckReport[0].FileGuid),'pdf')">
                                        查看
                                        <img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData2.CheckReport && formData2.CheckReport[0].FileGuid)">
                                    </a>
                                </li>
                            </ul>
                            <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData2.CheckReport && formData2.CheckReport[0].FileGuid)" download="检测报告单" title="下载"  target="_blank" class="download_a">
                                下载
                            </a>
                        </div>
                        <el-button size="small" type="primary" @click="uploadAuth2(2)">点击上传</el-button>
                        <!-- <el-button  :data-img="url2" type="text" size="small" @click="$imgPreview">示例</el-button> -->
                        <p class="tipText">请提供最近一次完整的检测报告单，支持pdf格式</p>

                    </el-form-item>
                    <el-form-item label="待撤文章位置:" prop="ArticleLocation" >
                        <!-- <p>{{formData2.ArticleLocation.FileName}}</p> -->
                        <!-- <el-input v-model="formData2.ArticleLocation[0].FileName" class="input_fileName" v-if="ifFileNmae3"></el-input> -->
                        <div :id="'indexImg_'+(formData2.ArticleLocation && formData2.ArticleLocation[0].FileGuid)" :ref="'indexImg_'+(formData2.ArticleLocation && formData2.ArticleLocation[0].FileGuid)" v-if="ifFileNmae7">
                            <ul style="display:inline-block;">
                                <li style="display:inline-block;" >
                                    <span  class="input_fileName" v-if="ifFileNmae7" style="display:inline-block;color:#606266;">
                                        {{formData2.ArticleLocation && formData2.ArticleLocation[0].FileName}}
                                    </span>
                                    <a class="view_a" target="_blank" id="test" @click="showImgFn(formData2.ArticleLocation && formData2.ArticleLocation[0].FileGuid)">
                                        查看
                                        <img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData2.ArticleLocation && formData2.ArticleLocation[0].FileGuid)">
                                    </a>
                                </li>
                            </ul>
                            <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData2.ArticleLocation && formData2.ArticleLocation[0].FileGuid)" download="待撤文章位置" title="下载"  target="_blank" class="download_a">
                                下载
                            </a>
                        </div>
                        <el-button size="small" type="primary" @click="uploadAuth2(3)">点击上传</el-button>
                        <el-button  :data-img="url2" type="text" size="small" @click="$imgPreview">示例</el-button>
                        <p class="tipText">请将待撤文章在检测报告单中的具体位置进行标注并上传标注后的附件，支持gif、png、jpg格式</p>
                    </el-form-item>
                </div>
                <div class="subBtn_box">
                    <el-form-item class="btn_box">
                        <el-button type="primary" @click="submitInfo2('formData2')" class="submit_btn" v-loading="regLoading">确定</el-button>
                        <!-- <el-button  type="primary" class="submit_btn">取消</el-button> -->
                    </el-form-item>
                </div>
            </el-form>
            <global-uploaderTwo></global-uploaderTwo>
        </el-tab-pane>
        <el-tab-pane label="互联网资源" name="first">
            <el-form :model="formData1"  ref="formData1" :rules="rulesData1" label-width="150px" class="demo-ruleForm myForm" style="width: 70%; margin: auto;">
                <div class="item_box">
                   <div class="title_sty">申请人基本信息</div>
                    <el-form-item label="申请人姓名:" prop="RequesterName" >
                        <el-input v-model="formData1 && formData1.RequesterName" class="inpItem"></el-input>
                    </el-form-item>
                    <el-form-item label="申请人电话:" prop="RequesterPhoneNum" >
                        <el-input v-model="formData1 && formData1.RequesterPhoneNum" disabled="disabled"></el-input>
                    </el-form-item>
                </div>
                <div class="item_box">
                    <div class="title_sty">待撤文章信息</div>
                    <el-form-item label="题目名称:" prop="ArticleName"  >
                        <el-input v-model="formData1 && formData1.ArticleName"></el-input>
                        <!-- <div class="el-upload__tip">请输入待撤文章的题目名称</div> -->
                    </el-form-item>
                    <el-form-item label="作者:" prop="Author" >
                        <el-input v-model="formData1 && formData1.Author"></el-input>
                        <!-- <div  class="el-upload__tip">请输入待撤文章的作者</div> -->
                    </el-form-item>
                    <el-form-item label="检测报告单:" prop="CheckReport" >
                        <div :id="'indexImg_'+(formData1.CheckReport[0] && formData1.CheckReport[0].FileGuid)" :ref="'indexImg_'+(formData1.CheckReport[0] &&formData1.CheckReport[0].FileGuid)" v-if="ifFileNmae2">
                            <ul style="display:inline-block;">
                                <li style="display:inline-block;" >
                                    <span  class="input_fileName" v-if="ifFileNmae2" style="display:inline-block;color:#606266;">
                                        {{ formData1.CheckReport[0] && formData1.CheckReport[0].FileName }}
                                    </span>
                                    <a class="view_a" target="_blank" id="test" @click="showImgFn(formData1.CheckReport[0] && formData1.CheckReport[0].FileGuid,'pdf')">
                                        查看
                                    <img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData1.CheckReport[0] && formData1.CheckReport[0].FileGuid)">
                                    </a>
                                </li>
                            </ul>
                            <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData1.CheckReport[0] && formData1.CheckReport[0].FileGuid)" download="检测报告单" title="下载"  target="_blank" class="download_a">
                                下载
                            </a>
                        </div>
                        <el-button size="small" type="primary" @click="uploadAuth1(2)">点击上传</el-button>
                        <p class="tipText">请提供最近一次完整的检测报告单，支持pdf格式</p>

                    </el-form-item>
                    <el-form-item label="待撤文章位置:" prop="ArticleLocation">
                        <div :id="'indexImg_'+(formData1.ArticleLocation[0] && formData1.ArticleLocation[0].FileGuid)" :ref="'indexImg_'+(formData1.ArticleLocation[0] && formData1.ArticleLocation[0].FileGuid)" v-if="ifFileNmae3">
                            <ul style="display:inline-block;">
                                <li style="display:inline-block;" >
                                    <span  class="input_fileName" v-if="ifFileNmae3" style="display:inline-block;color:#606266;">
                                        {{ formData1.ArticleLocation[0] && formData1.ArticleLocation[0].FileName }}
                                    </span>
                                    <a class="view_a" target="_blank" id="test" @click="showImgFn(formData1.ArticleLocation[0] && formData1.ArticleLocation[0].FileGuid)">
                                        查看
                                        <img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData1.ArticleLocation[0] &&formData1.ArticleLocation[0].FileGuid)">
                                    </a>
                                </li>
                            </ul>
                            <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+(formData1.ArticleLocation[0] && formData1.ArticleLocation[0].FileGuid)" download="待撤文章位置" title="下载"  target="_blank" class="download_a">
                                下载
                            </a>
                        </div>
                        <el-button size="small" type="primary" @click="uploadAuth1(3)">点击上传</el-button>
                        <el-button  :data-img="url1" type="text" size="small" @click="$imgPreview">示例</el-button>

                        <p class="tipText">请将待撤文章在检测报告单中的具体位置进行标注并上传标注后的附件，支持gif、png、jpg格式
                            <!-- <br>请一次性上传所有文件 -->
                        </p>
                    </el-form-item>
                </div>
                <div class="subBtn_box">
                    <el-form-item class="btn_box">
                        <el-button type="primary" @click="submitInfo1('formData1')" class="submit_btn" v-loading="regLoading">确定</el-button>
                        <!-- <el-button  type="primary" class="submit_btn">取消</el-button> -->
                    </el-form-item>
                </div>
            </el-form>
            <global-uploader></global-uploader>
        </el-tab-pane>
    </el-tabs>
    </div>
</template>
<script>
import Bus1 from '@/components/Upload/js/bus.js';
import Bus2 from '@/components/Upload/js/bus2.js';
import globalUploader from '@/components/Upload/globalUploader.vue'
import globalUploaderTwo from '@/components/Upload/globalUploader2.vue'
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    inject:['reload'],
    components:{globalUploader, globalUploaderTwo},
    data(){
        var validatePasswordAgin = (rule, value, callback) => {
            if(value==""){
                return callback(new Error('请输入确认密码'))
            }else if(value!==this.registParamsData.Password){
                return callback(new Error('两次密码输入不一致'))
            }else{
                callback();
            }
        }
        return{
            authImgUrl:BASE_URL,
            //require("../../../assets/UnitIdentification.docx")
            hrefUrl:"../../../static/UnitIdentification.docx",
            ifSmallImg:false,
            url: require("../../../assets/images/identImg.png"),
            srcList: [
            require("../../../assets/images/identImg.png"),
            // 'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
            ],
            url2:require("../../../assets/images/model_img.png"),
            url1: require("../../../assets/images/model_img1.jpg"),
            srcList2:[
                require("../../../assets/images/model_img.png"),
            ],
            ifFileNmae0:false,
            ifFileNmae1:false,
            ifFileNmae2:false,
            ifFileNmae3:false,

            ifFileNmae4:false,
            ifFileNmae5:false,
            ifFileNmae6:false,
            ifFileNmae7:false,
            // activeName: '',
            rulesData1: {
                RequesterName:  { required: true, message: '请输入申请人姓名', trigger: 'blur' },
                RequesterPhoneNum:{ required: true, message: '请输入申请人电话', trigger: 'blur' },
                RequesterOrganisation:{ required: true, message: '请输入所在单位', trigger: 'blur' },
                ArticleName:{ required: true, message: '请输入待撤除文章题目', trigger: 'blur' },
                Author:{ required: true, message: '请输入作者', trigger: 'blur' },
                UnitIdentification:{ required: true, message: '请上传单位允许撤除证明', trigger: 'blur' },
                // PersonIdentification:{required: true, message: '至少上传一个身份证明', trigger: 'blur'},
                CheckReport:{required: true, message: '请上传检测报告单', trigger: 'blur' },
                ArticleLocation:{required: true, message: '请上传待撤文章位置', trigger: 'blur' }
            },
            formData1:{
                "CommitType": 1,
                "RequesterName": "",
                "RequesterPhoneNum": sessionStorage.getItem("userName"),
                "RequesterOrganisation": "",
                "PersonIdentification": [],//0类型（身份证）
                "ArticleName": "",
                "Author": "",
                "Publication": "",
                "PublishTime": "",
                "UnitIdentification": [],//1类型上传
                "CheckReport": [], //2类型上传
                "ArticleLocation": [],//3类型上传
            },
            formData2:{
                "CommitType": 2,
                "RequesterName": "",
                "RequesterPhoneNum": sessionStorage.getItem("userName"),
                "RequesterOrganisation": "",
                "PersonIdentification": [],//0类型（身份证）
                "ArticleName": "",
                "Author": "",
                "Publication": "",
                "PublishTime": "",
                "UnitIdentification": [],//1类型上传
                "CheckReport": [], //2类型上传
                "ArticleLocation": [],//3类型上传
            },
            rulesData2: {
                RequesterName:  { required: true, message: '请输入申请人姓名', trigger: 'blur' },
                RequesterPhoneNum:{ required: true, message: '请输入申请人电话', trigger: 'blur' },
                RequesterOrganisation:{ required: true, message: '请输入所在单位', trigger: 'blur' },
                ArticleName:{ required: true, message: '请输入待撤除文章题目', trigger: 'blur' },
                Author:{ required: true, message: '请输入作者', trigger: 'blur' },
                UnitIdentification:{ required: true, message: '请上传单位允许撤除证明', trigger: 'blur' },
                PersonIdentification:{required: true, message: '至少上传一个身份证明', trigger: 'blur'},
                CheckReport:{required: true, message: '请上传检测报告单', trigger: 'blur' },
                ArticleLocation:{required: true, message: '请上传待撤文章位置', trigger: 'blur' }
            },
            updataType:null,
            updataType2:null,
            regLoading:false,
            // PersonIdentificationArr:[],
            PersonIdentificationArr2:[]
        }
    },
   
    mounted(){
    },
    computed:{
        activeName: {
            get: function () {
                var flag = false
                if(this.$route.query.type == 'first') {
                    flag = true
                    this.first()
                    return 'first'
                }
                if(!flag) {
                    this.second()
                    return 'second'
                }
            },
            set: function (newValue) {
                if(newValue == 'first' && this.$route.query.type == 'first') {
                   this.first()
                   return 'first'
                } else {
                    this.second()
                    return 'second'
                }
            }
        }
    },
    watch:{
        PersonIdentificationArr2(){
            var _this = this;
            if(_this.PersonIdentificationArr2.length>0){
                var arr = _this.PersonIdentificationArr2.filter((item, index) => _this.PersonIdentificationArr2.indexOf(item) === index);
                _this.formData2.PersonIdentification=arr
            }
        }
    },
    
    methods:{
        handleClick(e) {
            if(e.name == 'first') {
                this.$router.push({
                    name: '提交撤除申请',
                    params: {
                        formData: this.formData1
                    },
                    query: {
                        type: 'first'
                    }
                });
            } else {
                this.$router.push({
                    name: '提交撤除申请',
                    params: {
                        formData: this.formData2
                    },
                    query: {
                        type: 'second'
                    }
                });
            }
        },
        showImgFn(FileGuid,Clicktype){
            if(Clicktype){
                var url = this.authImgUrl+'/api/Common/GetOriginalFile?BatchID='+FileGuid;
                window.open(location.origin+location.pathname+'static/pdf/web/viewer.html?file=' + encodeURIComponent(url))
                console.log("location.origin+location.pathname",location.origin+location.pathname+'static/pdf/web/viewer.html?file=' + encodeURIComponent(url))
                return false;
            }
            var _this = this;
            // console.log("_this[FileGuid]=====",_this[FileGuid]);
            var ViewerDom = document.getElementById('indexImg_'+FileGuid);
            // console.log("ViewerDom===",ViewerDom)
            // debugger
            if(!_this[FileGuid]){
                _this[FileGuid] = new Viewer(document.getElementById('indexImg_'+FileGuid), {
                // 相关配置项,详情见下面
                inline: false,  //是否启用 inline 模式
                url: 'data-original',  //设置大图片的 url
                navbar: false,  //显示缩略图导航
                zoomRatio: 0.4,  //鼠标滚动时的缩放比例
                // minZoomRatio:0.01, //最小缩放比例
                // maxZoomRatio:100, //最大缩放比例
                // zIndex:2015, //设置图片查看器 modal 模式时的 z-index
                button: true,  //显示右上角关闭按钮（jQuery 版本无效）
                title: true,  //显示当前图片的标题（现实 alt 属性及图片尺寸）
                keyboard: true,  //是否支持键盘
                movable: true,  //图片是否可移动
                tooltip: true,  //显示缩放百分比
                // rotatable: true,  //图片是否可旋转
                // scalable: true,  //图片是否可翻转
                toolbar: {   //显示工具栏
                    zoomIn: 1,
                    zoomOut: 1,
                    oneToOne: 1,
                    reset: 1,
                    prev: 0,
                    play: 0,
                    next: 0,
                    rotateLeft: 1,
                    rotateRight: 1,
                    flipHorizontal: 1,
                    flipVertical: 1,
                },
                viewed: function () {
                    _this[FileGuid].view(0);
                }
            });
            }

            _this[FileGuid].show();

        },
        getBigImg(){
            this.ifSmallImg=true;
        },
        submitInfo1 (formData){
            var _this = this;
            _this.$refs[formData].validate(valid => {
                if(valid){
                    _this.regLoading = true
                    // _this.CommitRequest1(_this.formData1);
                    this.$router.push({
                        name: '撤除申请预览',
                        params: {
                            formData: _this.formData1,
                            type: 'first'
                        }
                    })
                    sessionStorage.setItem("formData1", JSON.stringify(this.formData1));
                }else{
                    this.$message({
                        message: "您存在未填写信息，请填写完整后再提交",
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
            })
        },
        CommitRequest1 (formData){
            formData.CommitType = '1'
            var _this = this;
            _this.$api.CommitRequest(formData).then(res=>{
                if(res.data.result){
                    this.$message({
                        message: "提交成功，请确认信息",
                        type: 'success',
                        duration: 5 * 1000
                    })
                    //this.$router.push('viewCancel');
                    this.$router.push({
                        name: '撤除申请预览',
                        params: {
                            formData: this.formData1,
                            type: 'first'
                        }
                    })
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                console.log(res)
            })
        },
        submitInfo2 (formData){
            var _this = this;
            _this.$refs[formData].validate(valid => {
                if(valid){
                    _this.regLoading = true
                    // _this.CommitRequest2(_this.formData2);
                    this.$router.push({
                        name: '撤除申请预览2',
                        params: {
                            formData: _this.formData2,
                            type: 'second'
                        }
                    })

                    sessionStorage.setItem("formData2", JSON.stringify(this.formData2));
                }else{
                    this.$message({
                        message: "您存在未填写信息，请填写完整后再提交",
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
            })
        },
        CommitRequest2 (formData){
            var _this = this;
            formData.CommitType = '2'
            _this.$api.CommitRequest(formData).then(res=>{
                if(res.data.result){
                    this.$message({
                        message: "提交成功，请确认信息",
                        type: 'success',
                        duration: 5 * 1000
                    })
                    //this.$router.push('viewCancel');
                    this.$router.push({
                        name: '撤除申请预览2',
                        params: {
                            formData: this.formData2,
                            type: 'second'
                        }
                    })
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                console.log(res)
            })
        },
       
        uploadAuth1 (single) {
            // console.log('single', single)
            // 打开文件选择框
            // console.log("BUs1=====》",Bus1);
            var _this = this;
            this.updataType=single
            console.log("开始的updataType11111---------->",this.updataType)
            if(single==0){
                // this.reload();
                //this.formData.PersonIdentification=[]
                // _this.PersonIdentificationArr=[];
                // console.log("开始---this.formData.PersonIdentification",this.formData.PersonIdentification)
            }
            
            Bus1.$emit('openuploaderone', {
                id: '1111' , // 传入的参数
                loginToken: sessionStorage.getItem("Token"),
                // ifAuth:true,
                single:single,
            })

        },
        uploadAuth2 (single) {
            // console.log('single-------->', single)
            // 打开文件选择框
            // console.log("BUs2=====》",Bus2);
            var _this = this;
            this.updataType2=single
            // console.log("开始的updataType22222------>",this.updataType2)
            if(single==0){
                // this.reload();
                //this.formData.PersonIdentification=[]
                _this.PersonIdentificationArr2=[];
                // console.log("开始---this.formData.PersonIdentification",this.formData.PersonIdentification)
            }
            //debugger
            Bus2.$emit('openuploadertwo', {
                id: '1111' , // 传入的参数
                loginToken: sessionStorage.getItem("Token"),
                //ifAuth:true
                single:single,
            })

        },
        first () {
            var _this = this;
            if(_this.$route.params.formData1 != undefined){
                _this.formData1 = _this.$route.params.formData1;
                // _this.ifFileNmae0=true
                // _this.ifFileNmae1=true
                _this.ifFileNmae2=true
                _this.ifFileNmae3=true
            }else if(sessionStorage.getItem("formData1") && sessionStorage.getItem("btnType")=="2"){
                _this.formData1 = JSON.parse(sessionStorage.getItem("formData1"));
                // _this.ifFileNmae0=true
                // _this.ifFileNmae1=true
                _this.ifFileNmae2=true
                _this.ifFileNmae3=true
            }
            // _this.formData2 = {}
            // _this.formData1.RequesterPhoneNum = sessionStorage.getItem("userName")
            
            Bus1.$on('fileadded1', (loginToken) => {
                // console.log('文件已选择11111111111');
            });
            
            // 文件上传成功的回调
            Bus1.$on('filesuccess1', query => {
                // console.log('query', query)
                // console.log('文件上传成功query111111==========》',query)
                // console.log("_this.updataType1111============>",query.singleFileType);
                if(query.singleFileType==0){
                    // _this.ifFileNmae0=true
                    // _this.PersonIdentificationArr.push(query);

                }else if(query.singleFileType==1){
                    // _this.ifFileNmae1=true
                    // _this.formData1.UnitIdentification=[];
                    // _this.formData1.UnitIdentification.push(query);
                }else if(query.singleFileType==2){
                    _this.ifFileNmae2=true
                    _this.formData1.CheckReport=[];
                    _this.formData1.CheckReport.push(query);

                }else if(query.singleFileType==3){
                    _this.ifFileNmae3=true
                    _this.formData1.ArticleLocation=[];
                    _this.formData1.ArticleLocation.push(query);
                }
                //console.log("_this.formData.PersonIdentification",_this.formData.PersonIdentification);
            });
        },
        second () {
            var _this = this;
            if(_this.$route.params.formData2 != undefined){
                _this.formData2 = _this.$route.params.formData2;
                _this.ifFileNmae4=true
                _this.ifFileNmae5=true
                _this.ifFileNmae6=true
                _this.ifFileNmae7=true
            }else if(sessionStorage.getItem("formData2")&&sessionStorage.getItem("btnType")=="2"){
                _this.formData2 = JSON.parse(sessionStorage.getItem("formData2"));
                _this.ifFileNmae4=true
                _this.ifFileNmae5=true
                _this.ifFileNmae6=true
                _this.ifFileNmae7=true
            }
            // _this.formData1 = {}
            // _this.formData2.RequesterPhoneNum = sessionStorage.getItem("userName")
            Bus2.$on('fileadded2', (loginToken) => {
                // console.log('文件已选择222222222');
            }); 
            
            // 文件上传成功的回调
            Bus2.$on('filesuccess2', query => {
                // console.log('文件上传成功query22222=======》',query)
                // console.log("_this.updataType2222222========>",query.singleFileType);
                if(query.singleFileType==0){
                    _this.ifFileNmae4=true
                    // console.log('query=========>', query)
                    _this.PersonIdentificationArr2.push(query);

                }else if(query.singleFileType==1){
                    _this.ifFileNmae5=true
                    _this.formData2.UnitIdentification=[];
                    _this.formData2.UnitIdentification.push(query);
                }else if(query.singleFileType==2){
                    _this.ifFileNmae6=true
                    _this.formData2.CheckReport=[];
                    _this.formData2.CheckReport.push(query);
                }else if(query.singleFileType==3){
                    _this.ifFileNmae7=true
                    _this.formData2.ArticleLocation=[];
                    _this.formData2.ArticleLocation.push(query);
                }
            });
        }
    },
    destroyed(){
        sessionStorage.setItem("btnType","");
        Bus1.$off('filesuccess1');
        Bus2.$off('filesuccess2');
    }


}
</script>
<style>
.input_fileName {
    line-height: 20px!important;
}
.input_fileName .el-input__inner{
    border:none!important;
    height:20px!important;
}
.myForm  input.el-input__inner{
    height:33px;
}
.el-tabs__content{
    background: #F0F2F5!important;
}
</style>
<style lang="scss" scoped>
.main_apply{
    // width:1300px;
}
.main_container{
    width:1100px;
}

.item_box{
    background: #fff;
    padding: 20px;
    margin-bottom: 10px;
    // border-radius: 10px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    border-radius: 10px;
}
.title_sty{
    font-size: 16px;
    // width: 1300px;
    color:#606266;
    border-bottom:1px solid #DCDFE6;
    margin-bottom: 10px;
    padding-bottom: 10px;

}
.inpItem{
    height:33px;
}
.el-form-item{
    margin-bottom: 14px;
}
.el-upload__tip{
    font-size: 12px;
    color: red;
    margin-top: 0px;
    height: 20px;
    line-height: 20px;
}
.subBtn_box{
    // padding-left:300px;
    // width:180px;
    // margin:auto;
    margin-left:0px;
    padding-left:120px;
}
.input_box{
    line-height: 20px;
}
.input_box .el-input,.input_box .el-input__inner{
    height: 20px;
    line-height: 20px;
    border:none;
}
.model_span{
    color:#409EFF;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// applyIndex.vue?0c7f6670